import { Component, EventEmitter, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationCodeService } from './service/validation-code.service';
import { ContactInformation } from '../contact-information/model/potential-customer';
import { SesionService } from 'src/app/core/service/sesion.service';

@Component({
  selector: 'app-validation-code',
  templateUrl: './validation-code.component.html',
  styleUrls: ['./validation-code.component.scss'],
})
export class ValidationCodeComponent implements OnInit {
  email: string = '';
  isEmail: boolean = true;
  phone: string;
  codeArray: string[] = new Array(6).fill('');
  codeSent: boolean = false;
  verificationSuccess: boolean = false;
  statusInitial: boolean = true;
  verificationError: string = '';
  customerForm: FormGroup;
  contacInformation: ContactInformation;
  @ViewChildren('codeInputs') codeInputs!: QueryList<any>;
  @Output()
  onComplete = new EventEmitter<number>();

  @Output()
  onBack = new EventEmitter();

  constructor(private fb: FormBuilder, public service: ValidationCodeService,  private sesion: SesionService,  ) {
    this.customerForm = this.fb.group({
      code0: ['', Validators.required],
      code1: ['', Validators.required],
      code2: ['', Validators.required],
      code3: ['', Validators.required],
      code4: ['', Validators.required],
      code5: ['', Validators.required],
      timer: [true, Validators.required],
      isEmail: [true, Validators.required]
    });

    this.contacInformation = JSON.parse(
      this.sesion.getItem("contact-information") || "{}"
    ) as ContactInformation;
    this.phone = this.contacInformation.telephone;
    this.email = this.contacInformation.email;
    this.customerForm.get('timer')?.valueChanges.subscribe(data=>{
      console.log('form', data);
    })

    for (let i = 0; i <= 5; i++) {
      const currentControlName = 'code' + i;
      const nextControlName = 'code' + (i + 1);
      const nextControlDelete = 'code' + (i - 1);
      this.customerForm.get(currentControlName)?.valueChanges.subscribe((value) => {
        if (value && value.length > 0 && value != ' ' && value != '') {
          this.verificationError = "";
          const nextControl = document.getElementsByName(nextControlName)[0] as HTMLInputElement;
          if (nextControl) {
            nextControl.focus();
          }
        } else if (value == '') {
          const nextControl = document.getElementsByName(nextControlDelete)[0] as HTMLInputElement;
          if (nextControl) {
            nextControl.focus(); // Cambiar el enfoque al campo anterior
          }
        }
      });
    }
  }

  onKeydown(event: KeyboardEvent, index: number) {
    const nextControlName = 'code' + (index + 1);
    const nextControlDelete = 'code' + (index - 1);
    const keyPressed = event.key;
    switch (event.key) {
      case 'ArrowLeft':
        console.log('Se ha presionado la tecla de flecha izquierda');
        const nextControlLeft = document.getElementsByName(nextControlDelete)[0] as HTMLInputElement;
        if (nextControlLeft) {
          nextControlLeft.focus(); // Cambiar el enfoque al campo anterior
        }
        break;
      case 'ArrowRight':
        const nextControlRigth = document.getElementsByName(nextControlName)[0] as HTMLInputElement;
        if (nextControlRigth) {
          nextControlRigth.focus();
        }
        console.log('Se ha presionado la tecla de flecha derecha');
        break;
    }
  }

  ngOnInit(): void {

  }

  back() {
    this.onBack.emit();
  }

  resendCode() {
    console.log('resend code');
    this.customerForm.get('timer')?.setValue(false);
    let contact = '';
    let type = '';
    if(this.isEmail){
      contact = this.email;
    }else{
      contact = this.phone;
    }
    this.service.sendCode({ contact, type: this.isEmail ? 'EMAIL' : 'SMS' }).subscribe({
      next: () => {},
      error: (error: unknown) => {
        this.verificationError = error instanceof Error ? error.message : 'No pudimos enviar el código. Intentá nuevamente.';
      },
    });
  }

  verifyCode(){
    if (!this.isEmail) {
      this.verificationError = 'La verificación por SMS todavía no está disponible.';
      return;
    }
    const email = '';
    let code = '';
    for (let i = 0; i <= 5; i++) {
      const currentControlName = 'code' + i;
      code = code + this.customerForm.get(currentControlName)?.value;
    }
    let contact = '';

    if(this.isEmail){
      contact = this.email;
    }else{
      contact = this.phone;
    }
    this.service.validateCode({ code, email: contact }).subscribe(data => {
      if(data === true){
        this.verificationSuccess = true;
      }else if(data === false){
        this.verificationSuccess = false;
        this.verificationError = '¡Codigo incorrecto!';
      }
    },
    (error: unknown) => {
      this.verificationSuccess = false;
      this.verificationError = error instanceof Error ? error.message : 'No pudimos verificar el código. Intentá nuevamente.';
    }   
  )

  }

  onSubmit() {
    this.onComplete.emit(7);
  }

  onPaste(event: ClipboardEvent, index: number) {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text').trim() || '';

    if (pastedText.length === 6) {
      this.codeArray = pastedText.split('');
      this.codeArray.forEach((digit, i) => {
        this.customerForm.get(`code${i}`)?.setValue(digit); 
      });
      this.verifyCode(); 
      this.verificationError = '¡Por favor, ingrese un código de 6 dígitos!';
    }
  }

  toggleValidationMethod(value:boolean): void {
    this.isEmail = value;
    this.verificationSuccess = false;
    this.verificationError = '';
    this.codeArray = new Array(6).fill('');
    if(this.customerForm.controls['timer'].value) {
      this.statusInitial = false;
      console.log('todavia no se nevio');
      this.resendCode();

    }
    //this.customerForm.get('timer')?.setValue(false);
    //this.sendCode();  // Enviar el código al nuevo método de validación
  }
}
